import { connect } from 'react-redux'
import UpdateChargebackStatusModal from './modal';

export default connect()(UpdateChargebackStatusModal);
